import { apiGet, apiPost, apiPut, apiDelete } from './api';
import { jwtDecode } from 'jwt-decode';

export const ALL_PERMISSIONS = [
  { key: 'dashboard', label: 'Twitter Manager' },
  { key: 'linkedin-management', label: 'LinkedIn Management' },
  { key: 'post-history', label: 'Post History' },
  { key: 'ppt', label: 'Manage PPT' },
  { key: 'social-media-settings', label: 'Social Media Settings' },
  { key: 'cookie-management', label: 'Cookie Management' },
];

export const getCurrentUser = () => {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

export const isAdmin = () => getCurrentUser()?.role === 'admin';

export const getUserPermissions = () => {
  const user = getCurrentUser();
  if (!user) return [];
  if (user.role === 'admin') return ALL_PERMISSIONS.map((p) => p.key);
  return Array.isArray(user.permissions) ? user.permissions : [];
};

export const hasPermission = (key) => {
  const user = getCurrentUser();
  if (!user) return false;
  if (user.role === 'admin') return true;
  return getUserPermissions().includes(key);
};

export const listUsers = () => apiGet('/users');

export const addUser = (email, name, role, permissions) =>
  apiPost('/users', { email, name, role, permissions });

export const updateUser = (email, role, permissions, name) =>
  apiPut(`/users/${encodeURIComponent(email)}`, { role, permissions, name });

export const deleteUser = (email) =>
  apiDelete(`/users/${encodeURIComponent(email)}`);
